/*
 * @Author: lixin jiang
 * @Date: 2021-07-15 13:00:34
 * @LastEditTime: 2021-07-19 22:07:41
 * @LastEditors: lixin jiang
 * @Description:
 * @FilePath: /aid-base/src/components/Demo/demo.tsx
 *
 */
// import React, { useState } from 'react';

function Demo() {
  // const [count, setCount] = useState(1);
  return (
    <>
      {/* <button type="button" onClick={() => setCount(count + 1)}>点击</button> */}
      <h2 className="aid-comp-demo">count</h2>
    </>
  );
}

export default Demo;
